import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { Button, Col, Row, Typography } from 'antd';
import WaypointEditTabs, {} from "./WaypointEditTabs";
import { ConsignmentStatusEnum, CreationSourceEnum } from "../api/Representation";
import { WaypointTransformer } from "../../../../../swzutils/ConsignmentUtil";
import { axiosErrorHandler, showErrorNotification } from "../../../../../swzutils";
import CreationSourceType from "../../../enums/CreationSourceType";
import ConsignmentResource from "../api/ConsignmentResource";
import { LoadingOutlined } from "@ant-design/icons";
const WaypointEditPage = () => {
    const params = useParams();
    const waypointEditTabsRef = useRef(null);
    const [pageTitle, setPageTitle] = useState("Delivery Address");
    const [consignment, setConsignment] = useState(null);
    const [waypoint, setWaypoint] = useState(null);
    const [isPickup, setIsPickup] = useState(false);
    const [readOnly, setReadOnly] = useState(false);
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    useEffect(() => {
        loadWaypoint(Number(params.consignmentId));
    }, [params.consignmentId, params.waypointId]);
    const onConsignmentLoaded = (consignment) => {
        const isCompleted = consignment.status == ConsignmentStatusEnum.COMPLETED;
        const waypointId = Number(params.waypointId);
        const isPickup = (consignment.pickupWaypointId === waypointId);
        const creationSource = CreationSourceType.valueOf(consignment.creationSource);
        if (isPickup) {
            setWaypoint(WaypointTransformer.extractPickupWaypoint(consignment));
            if (consignment.salesOrder && consignment.salesOrder.customerProjectStage) {
                setReadOnly(creationSource?.isPickupReadOnlyForProjectStage(consignment.salesOrder.customerProjectStage) ?? false);
            }
        }
        else if (consignment.deliveryWaypointId == waypointId) {
            setWaypoint(WaypointTransformer.extractDeliveryWaypoint(consignment));
            setReadOnly(isCompleted);
        }
        else {
            showErrorNotification("Invalid Waypoint Id");
            return;
        }
        setIsPickup(isPickup);
        setConsignment(consignment);
        const type = isPickup ? "Pickup" : "Delivery";
        setPageTitle(`Delivery ${consignment.consignmentRef} ${type} Address`);
    };
    const loadWaypoint = (consignmentId) => {
        ConsignmentResource.get(consignmentId, onConsignmentLoaded, axiosErrorHandler, () => { });
    };
    const backToCallingView = () => {
        if (searchParams.has("backUrl")) {
            // @ts-ignore
            navigate(searchParams.get("backUrl"));
        }
        else {
            navigate(`/app/consignments/view/${params.consignmentId}`);
        }
    };
    const validateAndSaveWaypoint = () => {
        waypointEditTabsRef.current?.validateAndSaveToServer()
            .then(backToCallingView)
            .catch(console.error);
    };
    return (_jsx("div", { className: "container-fluid", children: _jsxs("article", { className: "article", children: [_jsx("h2", { className: "article-title", children: pageTitle }), (consignment && waypoint) ?
                    _jsxs(_Fragment, { children: [_jsx(WaypointEditTabs, { ref: waypointEditTabsRef, tenantId: consignment.tenantId, consignmentId: consignment.id, overwriteAddressOnGeolocate: consignment.creationSource !== CreationSourceEnum.SALES_ORDER_API, waypoint: waypoint, isCreate: false, isPickup: isPickup, readOnly: readOnly, editContactsOnly: false }), _jsxs(Row, { gutter: 10, className: "no-margin", children: [!readOnly &&
                                        _jsx(Col, { xs: 12, sm: 6, children: _jsx(Button, { block: true, type: "primary", htmlType: "button", size: "large", onClick: validateAndSaveWaypoint, children: "Save" }) }), _jsx(Col, { xs: 12, sm: 6, children: _jsx(Button, { htmlType: "button", block: true, type: "default", onClick: backToCallingView, size: "large", children: readOnly ? "Back" : "Cancel" }) })] }), _jsx("p", { children: "\u00A0" })] })
                    :
                        _jsxs(Typography.Title, { className: "text-center", children: [_jsx(LoadingOutlined, { spin: true }), " Loading..."] })] }) }));
};
export default WaypointEditPage;
